<template>
    <button type="button" @click="handleClick" class="c-a-button" :class="classes">
        <icon v-if="state.icon" :icon="state.icon" :class="state.iconClasses"></icon>
        {{state.label}}
    </button>
</template>

<script>
    import merge from 'deepmerge';
    import Icon from './AtomIcon.vue';

    export default {
        props: {
            currentState: {
                type: String,
                default: 'default'
            },
            customStates: {
                type: Object,
                default: function() { return {} }
            },
            disabled: Boolean
        },
        components: {
            Icon
        },
        computed: {
            states: function() {
                const defaultStates = {
                    default: {
                        label: 'Spara',
                        classes: 'c-a-button--theme-primary',
                        icon: '',
                        iconClasses: ''
                    },
                    processing: {
                        label: 'Sparar',
                        classes: 'c-a-button--theme-primary',
                        icon: 'spinner',
                        iconClasses: 'c-a-icon--animation-spinner'
                    },
                    success: {
                        label: 'Sparat!',
                        classes: 'c-a-button--theme-success',
                        icon: 'check',
                        iconClasses: ''
                    },
                    error: {
                        label: 'Fel!',
                        classes: 'c-a-button--theme-alert',
                        icon: 'close',
                        iconClasses: ''
                    }
                }

                return merge(defaultStates, this.customStates);
            },
            state: function() {
                return this.states[this.currentState];
            },
            classes: function() {
                let classes = '';
                classes += this.state.classes
                classes += this.icon ? 'c-a-button--with-icon ' : '';
                classes += this.disabled ? 'c-a-button--disabled ' : ''
                return classes
            }
        },
        methods: {
            handleClick(event) {
                if (this.disabled) {return false};
                event.preventDefault();
                this.$emit('buttonClicked', event);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/atoms/AtomSuccessButton.vue